// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__1HFw9","disabledMargin":"Description_disabledMargin__3Jq-4"};